import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { formatRupiah, formatDateTime, PAYMENT_LABEL } from "@/lib/api";

export const normalizeWa = (raw) => {
  let n = raw.replace(/\D/g, "");
  if (n.startsWith("0")) n = "62" + n.slice(1);
  else if (n.startsWith("8")) n = "62" + n;
  return n;
};

export const buildReceiptText = (tx, store) => {
  const lines = [`*${store.name || "Toko Saya"}*`];
  if (store.address) lines.push(store.address);
  if (store.whatsapp) lines.push(`WA: ${store.whatsapp}`);
  lines.push("", `No: ${tx.invoice_no}`, `Tanggal: ${formatDateTime(tx.created_at)}`, "--------------------");
  tx.items.forEach((i) => lines.push(i.option_label ? `${i.name} (${i.option_label})` : i.name, `  ${i.qty} x ${formatRupiah(i.price)} = ${formatRupiah(i.subtotal)}`));
  lines.push("--------------------");
  if (tx.delivery_method === "antar") {
    lines.push(`Subtotal: ${formatRupiah(tx.subtotal)}`, `Ongkir: ${formatRupiah(tx.shipping_fee)}`);
  }
  lines.push(`*TOTAL: ${formatRupiah(tx.total)}*`, `Bayar: ${PAYMENT_LABEL[tx.payment_method]}`);
  if (tx.payment_method === "tunai") lines.push(`Tunai: ${formatRupiah(tx.cash_paid)}`, `Kembali: ${formatRupiah(tx.change)}`);
  if (tx.delivery_method === "antar") lines.push(`Diantar ke: ${tx.delivery_address || "-"}`);
  lines.push("", "Terima kasih telah berbelanja");
  return lines.join("\n");
};

export const WhatsAppShare = ({ tx, store }) => {
  const [phone, setPhone] = useState("");

  useEffect(() => setPhone(tx?.customer_wa || ""), [tx?.id, tx?.customer_wa]);

  const send = () => {
    const n = normalizeWa(phone);
    if (n.length < 10 || n.length > 15) return toast.error("Nomor WhatsApp tidak valid");
    const url = `https://wa.me/${n}?text=${encodeURIComponent(buildReceiptText(tx, store))}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="no-print flex gap-2" data-testid="wa-share">
      <Input
        inputMode="tel"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && send()}
        placeholder="No. WA pembeli, mis. 0812..."
        data-testid="wa-phone-input"
      />
      <Button type="button" onClick={send} disabled={!phone.trim()} className="shrink-0 bg-[#25D366] text-white hover:bg-[#1ebe5a]" data-testid="wa-send-button">
        <MessageCircle className="mr-1.5 h-4 w-4" /> Kirim WA
      </Button>
    </div>
  );
};
